import { createFileRoute } from '@tanstack/react-router';
import { ChangePasswordTab } from '@/features/auth/components/change-password-tab/ChangePasswordTab';

export const Route = createFileRoute('/_authenticated/profile/security')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="mt-6">
      <ChangePasswordTab />
    </div>
  );
}
